import LightModel from "./light";

export default LightModel;
